import grid from './gridSection';
var navigation = [{
  id: 'customer-service-heading',
  title: 'Need help?',
  links: [{
    dataTest: 'footer-help-home',
    href: '/help',
    text: 'Help & FAQs'
  }, {
    dataTest: 'footer-contact-us',
    href: '/help/contact-us',
    text: 'Contact us'
  }, {
    dataTest: 'footer-store-finder',
    href: '/stores',
    text: 'Store finder'
  }, {
    dataTest: 'footer-account',
    href: '/account/login',
    text: 'Account'
  }, {
    dataTest: 'footer-advice',
    href: '/features/advice-and-inspiration',
    text: 'Advice & inspiration'
  }]
}, {
  id: 'delivery-and-returns-heading',
  title: 'Delivery & returns',
  links: [{
    dataTest: 'footer-delivery-collection',
    href: '/help/delivery-and-collection',
    text: 'Delivery & collection'
  }, {
    dataTest: 'footer-returns',
    href: '/order/tracking?type=returns',
    text: 'Returns'
  }, {
    dataTest: 'footer-refunds',
    href: '/help/returns-and-refunds',
    text: 'Refunds'
  }, {
    dataTest: 'footer-track-your-order',
    href: '/order/tracking',
    text: 'Track your order'
  }],
  subSection: {
    id: 'product-care',
    title: 'Product care',
    links: [{
      dataTest: 'footer-care',
      href: '/help/argos-care',
      text: 'Argos Care'
    }, {
      dataTest: 'footer-product-support',
      href: 'https://www.argos-support.co.uk/',
      text: 'Product Support'
    }, {
      dataTest: 'footer-product-recall',
      href: '/events/safety-product-recalls',
      text: 'Product recall'
    }, {
      dataTest: 'footer-spares',
      href: 'http://www.argosspares.co.uk/',
      text: 'Argos Spares'
    }]
  }
}, {
  id: 'payment-and-services',
  title: 'Payment & services',
  links: [{
    dataTest: 'footer-ways-to-pay',
    href: 'https://help.argos.co.uk/help/your-ways-to-pay',
    text: 'Ways to pay'
  }, {
    dataTest: 'footer-our-services',
    href: '/features/our-services',
    text: 'Our Services'
  }, {
    dataTest: 'footer-gift-cards',
    href: '/help/gift-cards',
    text: 'Gift cards'
  }, {
    dataTest: 'footer-voucher-codes',
    href: '/events/voucher-discount-codes',
    text: 'Voucher codes'
  }, {
    dataTest: 'footer-egift-cards-rewards',
    href: '/features/egift-card-rewards',
    text: 'eGift Card Rewards'
  }, {
    dataTest: 'footer-argos-card',
    href: '/help/argos-card',
    text: 'Argos Card'
  }, {
    dataTest: 'footer-klarna',
    href: 'https://help.argos.co.uk/help/argos-klarna',
    text: 'Klarna'
  }, {
    dataTest: 'footer-paypal',
    href: 'https://help.argos.co.uk/help/argos-paypal',
    text: 'PayPal'
  }, {
    dataTest: 'footer-nectar-argos',
    href: '/help/nectar',
    text: 'Nectar at Argos'
  }, {
    dataTest: 'footer-pet-insurance',
    href: 'https://www.argospetinsurance.co.uk/?utm_source=argos.co.uk&utm_medium=referral&utm_campaign=ARG_footer',
    text: 'Pet Insurance'
  }, {
    dataTest: 'footer-furniture-recycling',
    href: 'https://help.argos.co.uk/help/products-and-services/clearabee-information-page/clearabeeinfopage',
    text: 'Furniture Recycling'
  }]
}, {
  id: 'about-heading',
  title: 'About Argos',
  links: [{
    dataTest: 'footer-about-argos',
    href: 'https://corporate.sainsburys.co.uk/about-us/our-brands/',
    text: 'About us'
  }, {
    dataTest: 'footer-part-of-the-family',
    href: 'https://www.sainsburysforbusiness.co.uk',
    text: 'Argos for Business'
  }, {
    dataTest: 'footer-careers',
    href: 'https://sainsburys.jobs',
    text: 'Careers'
  }, {
    dataTest: 'footer-press-enquiries',
    href: 'https://corporate.sainsburys.co.uk/contact-us/',
    text: 'Press enquiries'
  }, {
    dataTest: 'footer-modern-slavery-statement',
    href: 'https://corporate.sainsburys.co.uk/sustainability/explore-by-a-z/people-in-our-supply-chain/standing-up-to-modern-slavery/',
    text: 'Modern Slavery Statement'
  }]
}];
var brands = [[{
  name: 'argos',
  dataTest: 'footer-link-img-argos',
  linkAttributes: {
    href: '//www.argos.co.uk',
    target: '_blank'
  }
}, {
  name: 'sainsburys',
  dataTest: 'footer-link-img-sainsburys',
  linkAttributes: {
    href: '//www.sainsburys.co.uk/shop/gb/groceries',
    target: '_blank'
  }
}, {
  name: 'tu',
  dataTest: 'footer-link-img-tu',
  linkAttributes: {
    href: '//tuclothing.sainsburys.co.uk/',
    target: '_blank'
  }
}], [{
  name: 'habitat',
  dataTest: 'footer-link-img-habitat',
  linkAttributes: {
    href: '//www.habitat.co.uk/',
    target: '_blank'
  }
}, {
  name: 'nectar',
  dataTest: 'footer-link-img-nectar',
  linkAttributes: {
    href: '//www.nectar.com',
    target: '_blank'
  }
}]];
var legal = {
  legalText: 'Argos Limited is authorised and regulated by the Financial Conduct Authority as a credit broker (713206), and works with the lender, Home Retail Group Card Services Limited trading as Argos Card and Argos Financial Services, who are authorised and regulated by the Financial Conduct Authority to provide credit (716148). Home Retail Group Card Services Limited is registered in England (04007072) at 33 Charterhouse Street, London, EC1M 6HA.',
  carePolicyText: 'Argos Care policies are provided by Domestic & General Insurance PLC, who are an insurer not an intermediary. They have not given you a personal recommendation as to whether this policy is suitable for your needs.'
};
var paypalCredit = {
  aprText: 'Representative example, provided by PayPal Credit: assumed credit limit £1,200, representative 23.9% APR (variable), purchase rate 23.9% p.a. (variable). Subject to status, terms and conditions apply.',
  legalText: 'PayPal Credit and PayPal Pay in 3 are trading names of PayPal UK ltd, 5 Fleet Place, London, United Kingdom, EC4M 7RD. Terms and conditions apply. Credit subject to status, UK residents only. Argos Limited acts as a broker and offers finance from a restricted range of finance providers. PayPal Pay in 3 is not regulated by the Financial Conduct Authority. Pay in 3 eligibility is subject to status and approval. 18+ UK residents only. Pay in 3 is an unregulated credit agreement. Check if affordable and how you will repay. May make other borrowing more difficult or expensive. See product terms for more details.'
};
var argosPayText = {
  legalText: 'Argos Limited is a credit broker and not a lender, introducing Argos Pay under an exclusive arrangement with the lender NewDay Ltd.',
  termsText: 'Argos Pay is provided by NewDay Ltd. UK residents aged 18 and over. Subject to status. Terms apply.'
};
var klarnaText = {
  legalText: "Klarna's Pay in 3 / Pay in 30 days are unregulated credit agreements. Borrowing more than you can afford or paying late may negatively impact your financial status and ability to obtain credit. 18+, UK residents only. Subject to status. Ts&Cs and late fees apply."
};
var argos = {
  navigation: navigation,
  grid: grid,
  brands: brands,
  legal: legal,
  paypalCredit: paypalCredit,
  argosPayText: argosPayText,
  klarnaText: klarnaText
};
export default argos;